<template>
    <div>
        <slot name="pickAll" />
        <div class="pad:grid pad:grid-cols-2 pad:gap-4">
            <Card
                v-for="item in data"
                :key="item.fullPolicyNo"
                :cursorPointer="true"
                :disabled="disabled"
                :tagText="item.memo"
                class="sm:max-w-[30rem] mb-4 last:mb-0 md:mb-0"
                @click="$emit('checkedPolicy', item.fullPolicyNo)"
            >
                <template #title>
                    <div
                        v-if="!disabled"
                        class="flex items-center"
                    >
                        <Checkbox
                            :checkedValues="selectedList"
                            :value="item.fullPolicyNo"
                            borderLight
                            name="card"
                            class="items-baseline mb-0 mr-0"
                            @change="$emit('checkedPolicy', item.fullPolicyNo)"
                        />
                        {{ item.fullPolicyNo }}
                    </div>
                    <span v-else>
                        {{ item.fullPolicyNo }}
                    </span>
                </template>
                <template #topContent>
                    <CardSubtitle
                        :text="item.itemName"
                        :disabled="disabled"
                    />
                    <CardRow
                        label="目前繳費方式"
                        :value="item.bankName + item.payKindText"
                        :disabled="disabled"
                    />
                </template>
                <template #foldContent>
                    <CardRow
                        label="被保險人"
                        :value="item.name"
                        :disabled="disabled"
                    />
                    <CardRow
                        label="幣別"
                        :value="item.currencyText"
                        :disabled="disabled"
                    />
                    <CardRow
                        label="備註"
                        :value="getMemo(item)"
                        :disabled="disabled"
                    />
                </template>
            </Card>
        </div>
    </div>
</template>

<script>
import Checkbox from '@/components/checkboxs/Checkbox.vue';
import Card from '@/components/card/CardPolicyBase.vue';
import CardRow from '@/components/card/CardRow.vue';
import CardSubtitle from '@/components/card/CardSubtitle.vue';
import { EUDC } from '@/utils/EUDC';

export default {
    components: {
        Card,
        Checkbox,
        CardRow,
        CardSubtitle
    },
    props: {
        selectedList: {
            type: Array,
            default: () => []
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        data: {
            type: Array,
            default: () => []
        },
    },
    emits: ['checkedPolicy'],
    setup() {
        EUDC();
        const getMemo = (item) => {
            if (item.memo) {
                return item.memo;
            } else if (item.description){
                return item.description;
            }else{
                return "";
            }
        };

        return {
            getMemo,
        };
    }
};
</script>
